import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APIService } from 'src/app/core/api/general.service';

import { ItineraryService } from '../services/itinerary.service';
import { OperationLogService } from '../services/operation-log.service';
import { LayoutService } from 'src/app/layout/services/layout.service';
import { OptionType } from 'src/app/core/enums/enums';

@Injectable({ providedIn: 'root' })
export class AirCompanyNoteGuard implements CanActivate {
  constructor(
    private api: APIService,
    private itineraryService: ItineraryService,
    private operationService: OperationLogService,
    private layoutService: LayoutService
  ) {}

  private loadAirCompanyNotes(
    pnr: string,
    officeId: string,
    country: string,
    gds: string,
    bookingCode: string
  ) {
    return this.api.getAirCompanyNotes(pnr, officeId, country, gds, bookingCode).pipe(
      map((response) => {
        this.layoutService.dispatchChangeBreadcrumb(pnr, OptionType.AirCompanyNotes);
        this.operationService.dispatchLoadAirCompanyNotesSuccess(response);
        return true;
      }),
      catchError((response) => {
        this.itineraryService.dispatchGenericError(response);
        this.itineraryService.navigateToWithParams('itinerary/info');
        return of(false);
      })
    );
  }

  canActivate(route?: ActivatedRouteSnapshot) {
    return this.loadAirCompanyNotes(
      route?.queryParams?.pnr,
      route?.queryParams?.officeId,
      route?.queryParams?.country,
      route?.queryParams?.gds,
      route?.queryParams?.bookingCode
    );
  }
}
